import { useMediaQuery } from '@jotta/hooks'

import { Breakpoint } from '../themes/breakpoints'
import type { BreakpointValue } from '../themes/breakpoints'

export const useBreakpoint = (breakpoint: Breakpoint) =>
  useMediaQuery(`(min-width: ${breakpoint}px)`)

export { Breakpoint, BreakpointValue }
